/** 无限画布视频节点 · 清晰度（与 NodeGraphCanvas / Seedance 一致） */
export const NGC_VIDEO_RESOLUTIONS = ['480p', '720p', '1080p']

export const NGC_VIDEO_RESOLUTION_LABELS = {
  '480p': '480P',
  '720p': '720P',
  '1080p': '1080P'
}

/** 后台默认定价示例（积分/秒） */
export const DEFAULT_VIDEO_RESOLUTION_CREDITS = {
  '480p': 18,
  '720p': 27,
  '1080p': 45
}

export function normalizeVideoResolution(raw) {
  const s = String(raw != null ? raw : '720p')
    .trim()
    .toLowerCase()
  return NGC_VIDEO_RESOLUTIONS.includes(s) ? s : '720p'
}
